import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { DatagridConfigurable, FunctionField, List, TextField, ReferenceField, TextInput, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { Typography } from "@mui/material";
import { generateRowClickHandler } from "../../services/RowClickService";
import { useTenantStore } from "../../providers/TenantContextProvider";
import { usePresentationName } from "../../hooks/usePresentationName";
var OMIT_FIELDS = ["id"];
var Filters = [
    _jsx(TextInput, { source: "election_event_id" }, 0),
    _jsx(TextInput, { source: "area_id" }, 1),
    _jsx(TextInput, { source: "contest_id" }, 2),
];
export var ListAreaContest = function (_a) {
    var aside = _a.aside;
    var tenantId = useTenantStore()[0];
    var _b = React.useState(false), openDrawer = _b[0], setOpenDrawer = _b[1];
    var presentationName = usePresentationName();
    var rowClickHandler = generateRowClickHandler(["election_event_id", "contest_id", "area_id"]);
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h5", children: "Area Contests" }), _jsx(List, { actions: _jsx(ListActions, { open: openDrawer, setOpen: setOpenDrawer }), sx: { flexGrow: 2 }, aside: aside, filter: {
                    tenant_id: tenantId || undefined,
                }, filters: Filters, children: _jsxs(DatagridConfigurable, { rowClick: rowClickHandler, omit: OMIT_FIELDS, children: [_jsx(TextField, { source: "id" }), _jsx(ReferenceField, { label: "Election Event", reference: "sequent_backend_election_event", source: "election_event_id", children: _jsx(FunctionField, { render: presentationName }) }), _jsx(ReferenceField, { label: "Area", reference: "sequent_backend_area", source: "area_id", children: _jsx(TextField, { source: "name" }) }), _jsx(ReferenceField, { label: "Contest", reference: "sequent_backend_contest", source: "contest_id", children: _jsx(FunctionField, { render: presentationName }) })] }) })] }));
};
